import React from 'react';
import './DashboardTablePage.css';
import Sidebar from '../../components/sidebar/Sidebar';
import AdminCaseUserEdit from "../../components/adminCaseUserEdit/AdminCaseUserEdit";

const AdminCaseUserPage = () => {
    return (
        <div className={"dashboard-page"}>
            <div className="dashboard-bggg">
                <div className="dashboard-flex-containerr">
                    <Sidebar />
                    <AdminCaseUserEdit />
                </div>
            </div>
        </div>
    );
};

export default AdminCaseUserPage;
